import { KEY_SETTINGS_STORAGE } from '~/constants';
import { getFromSessionStorage, saveToSessionStorage } from '~/helpers/storage';

interface ISetting {
  '@type': 'SettingsValue';
  'settingsCode': string;
  'settingsPath': string;
  'settingsHash': string;
  'settingsValue': string | number | boolean;
  'settingsDomain': string;
  'settingsItems': any;
}

const changeSetting = (
  setting: ISetting,
  changeValue: string | number | boolean
): ISetting => {
  return { ...setting, settingsValue: changeValue };
};

const updateSetting = (
  settingsCode: string,
  changeValue: string | number | boolean
) => {
  const currentSettingsArray = getFromSessionStorage(
    KEY_SETTINGS_STORAGE,
    'settings'
  );
  if (currentSettingsArray) {
    const changeSettingsArray = currentSettingsArray.map((setting: ISetting) => {
      return settingsCode === setting.settingsCode
        ? changeSetting(setting, changeValue)
        : setting;
    });
    saveToSessionStorage(KEY_SETTINGS_STORAGE, 'settings', changeSettingsArray);
    window.location.reload();
  } else {
    console.info('Настройки не обнаружены в SessionStorage');
  }
};

/**
 * Инициализирует утилиту для управления настройками из консоли
 */
export const initManagementSettings = () => {
  window.sberLeadManagementSettings = {
    updateSetting,
  };
};
